import React, { FC } from 'react'
import { Col, Dropdown, Menu, Row, Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

// assets
import { ReactComponent as ChevronDownIcon } from '../../assets/icons/BaseMiniIcons/chevron-down-3-icon.svg'
import { ReactComponent as LogOutIcon } from '../../assets/icons/BaseIcons/logout-1-icon.svg'
import { ReactComponent as AdminAvatar } from '../../assets/images/paradigma-admin-logo.svg'

// utils
import { PAGE, BASE_MENU_TAB_PATHS, ROLES } from '../../utils/enums'

// reducers
import { RootState } from '../../reducers'
import { logOutUser } from '../../reducers/authorization/authActions'

const { TabPane } = Tabs

type Props = {
	page?: BASE_MENU_TAB_PATHS
}

const LayoutBaseHeader: FC<Props> = (props) => {
	const [t] = useTranslation()
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { page } = props

	const loginUserData = useSelector((state: RootState) => state.auth)
	const BEVersion = useSelector((state: RootState) => state.versions.versions)
	const iFrameVersion = useSelector((state: RootState) => state.versions.iframeVersions)

	/* routing to another components inside of form builder */
	const onTabClicked = (key: string) => {
		if (key === PAGE.FORMS) {
			navigate(`/${BASE_MENU_TAB_PATHS.FORMS}`)
		} else if (key === PAGE.TEMPLATES) {
			navigate(`/${BASE_MENU_TAB_PATHS.TEMPLATES}`)
		} else if (key === PAGE.USERS) {
			navigate(`/${BASE_MENU_TAB_PATHS.USERS}`)
		}
	}

	const renderUserRole = (role?: string) => {
		if (role === ROLES.ADMINISTRATOR) {
			return t('loc:Admin')
		}
		return role
	}

	const menu = (
		<Menu>
			<Menu.Item onClick={() => dispatch(logOutUser())} key='1' className={'pb-2'}>
				<LogOutIcon /> {t('loc:Log out')}
			</Menu.Item>
			<div className={'version mx-3 pt-3'}>
				<div className={'version-info text-gray-500 text-xs tracking-wider'}>{`BE v${BEVersion.originalData}`}</div>
				<div className={'version-divider rounded-full mx-2'} />
				<div className={'version-info text-gray-500 text-xs tracking-wider'}>{`FE v${process.env.REACT_APP_VERSION}`}</div>
				{iFrameVersion?.originalData && (
					<>
						<div className={'version-divider rounded-full mx-2'} />
						<div className={'version-info text-gray-500 text-xs tracking-wider'}>{`iF v${iFrameVersion.originalData}`}</div>
					</>
				)}
			</div>
		</Menu>
	)

	return (
		<div className={'form-builder-header'}>
			<div className={'left-box-form-builder-header'}>
				<Dropdown className={'header-user-dropdown-box height-auto '} overlay={menu}>
					<div>
						<Row className={'w-full h-full'} justify={'space-between'}>
							<Col span={5}>
								<div className={'w-full h-full grid items-center'}>
									<AdminAvatar className={'m-0 ml-2 w-10 h-10'} />
								</div>
							</Col>
							<Col span={16} className={'my-2'}>
								<div className={'grid grid-cols-1 gap-2 place-content-stretch user'}>
									<div className={'text-gray-900 font-medium leading-none'}>{loginUserData?.authUser?.data?.fullName}</div>
									<div className={'text-gray-500 font-regular leading-none user-role'}>
										{renderUserRole(loginUserData?.authUser?.data?.role)}
									</div>
								</div>
							</Col>
							<Col span={3}>
								<div className={'grid justify-items-center justify-start'}>
									<ChevronDownIcon className={'ml-auto'} />
								</div>
							</Col>
						</Row>
					</div>
				</Dropdown>
			</div>
			<div className={'middle-box-form-builder-header ml-5 flex flex-wrap content-end'}>
				<Tabs tabBarStyle={{ margin: '0' }} onTabClick={onTabClicked} defaultActiveKey={page as string}>
					<TabPane tab={t('loc:Forms')} key={PAGE.FORMS} />
					<TabPane tab={t('loc:Templates')} key={PAGE.TEMPLATES} />
					<TabPane tab={t('loc:Users')} key={PAGE.USERS} />
				</Tabs>
			</div>
		</div>
	)
}

export default LayoutBaseHeader
